import Swiper, {Navigation} from 'swiper';

document.addEventListener('DOMContentLoaded', function () {
    Swiper.use([Navigation]);
    var swiper = new Swiper(".catalog-similar", {
        slidesPerView: 'auto',
        loop: true,
        spaceBetween: 15,
        centeredSlides: true,
        navigation: {
            prevEl: ".catalog-category-block__prev",
            nextEl: ".catalog-category-block__next",
        },
        breakpoints: {
            768: {
                centeredSlides: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            1200: {
                centeredSlides: false,
                slidesPerView: 4,
                spaceBetween: 30,
            }
        }
    });
});